<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    <button
                        @click="save()"
                        :disabled="checkBilletStatus"
                        :class="{'cursor-not-allowed opacity-50': checkBilletStatus}"
                        class="bg-yellow-500 hover:bg-yellow-600 text-white text-base font-bold uppercase my-0 -mt-10 py-2 px-4 rounded">
                        Alterar
                    </button>
                    <a
                        class="bg-gray-800 hover:bg-gray-900 text-white text-base font-bold uppercase my-0 -mt-10 py-2 px-4 rounded"
                        target="_blank"
                        v-bind:href="`/print/boleto/${boleto.id}`">
                        <i class="fas fa-print mx-1"></i> Imprimir
                    </a>
                </div>
                <inertia-link class="font-semibold text-xl text-gray-800 leading-tight" :href="route('boleto.index')">
                    <i class="fas fa-arrow-left mx-1"></i> Gerenciar boletos bancários
                </inertia-link>
            </div>
        </template>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <flash :timeout="5000"/>

                <template>
                    <jet-form-section>
                        <template #title>
                            Sacado / Pagador
                        </template>

                        <template #description>
                            Dados de quem pagará o boleto
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="payer_mame" value="Nome"/>
                                <jet-input id="payer_name" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.pagador.nomeRazao"/>
                                <jet-input-error :message="form.error('pagador.nomeRazao')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="payer_street" value="Logradouro"/>
                                <jet-input id="payer_street" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.pagador.logradouro"/>
                                <jet-input-error :message="form.error('pagador.logradouro')" class="mt-2"/>
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <jet-label for="payer_zip_code" value="CEP"/>
                                <jet-input id="payer_zip_code" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.pagador.CEP"/>
                                <jet-input-error :message="form.error('pagador.CEP')" class="mt-2"/>
                            </div>
                            <div class="col-span-2 sm:col-span-3">
                                <jet-label for="payer_city" value="Cidade"/>
                                <jet-input id="payer_city" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.pagador.cidade"/>
                                <jet-input-error :message="form.error('pagador.cidade')" class="mt-2"/>
                            </div>
                            <div class="col-span-2 sm:col-span-1">
                                <jet-label for="payer_state" value="UF"/>
                                <jet-input id="payer_state" type="text" class="mt-1 block w-full text-lg"
                                           v-model="form.pagador.uf"/>
                                <jet-input-error :message="form.error('pagador.uf')" class="mt-2"/>
                            </div>

                        </template>
                    </jet-form-section>
                </template>

                <jet-section-border/>


                <template>
                    <jet-form-section>
                        <template #title>
                            Pagamento
                        </template>

                        <template #description>
                            Informe o valor e as taxas do boleto
                        </template>

                        <template #form>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="boleto_code" value="Código do registro"/>
                                <jet-input
                                    class="mt-1 block w-full text-lg"
                                    readonly="readonly"
                                    v-model="form.codigoBoleto"
                                />
                            </div>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="boleto_code" value="Linha digitável"/>
                                <jet-masked-input
                                    class="mt-1 block w-full text-lg"
                                    readonly="readonly"
                                    :mask="['#####.##### #####.###### #####.###### # ##############']"
                                    v-model="form.numLinhaDigtvl"
                                />
                            </div>
                            <div class="col-span-6 sm:col-span-6">
                                <jet-label for="boleto_barcod" value="Código de barras"/>
                                <jet-input
                                    class="mt-1 block w-full text-lg"
                                    readonly="readonly"
                                    v-model="form.numCodBarras"
                                />
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="amount" value="Valor"/>
                                <jet-decimal id="amount" type="text" class="mt-1 block w-full text-lg"
                                             v-model="form.dadosBoleto.vlrTitulo"/>
                                <jet-input-error :message="form.error('amount')" class="mt-2"/>
                            </div>
                            <div class="col-span-6 sm:col-span-4"></div>
                            <!-- datas -->
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="custom_number" value="Nosso número"/>
                                <jet-input
                                    id="custom_number" class="mt-1 block w-full"
                                    v-model="form.dadosBoleto.numDocTit"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="due_date" value="Vencimento"/>
                                <jet-date-picker
                                    id="due_date" class="mt-1 block w-full"
                                    :disabled-dates="{to: new Date()}"
                                    v-model="form.dadosBoleto.dtVencimento"/>
                            </div>
                            <div class="col-span-6 sm:col-span-2">
                                <jet-label for="limit_date" value="Data limite"/>
                                <jet-date-picker
                                    id="limit_date" class="mt-1 block w-full"
                                    :disabled-dates="{to: moment(form.dadosBoleto.dtVencimento).toDate() || null}"
                                    v-model="form.dadosBoleto.dtLimPgto"/>
                            </div>

                            <div class="col-span-6 sm:col-span-6 text-right">
                                <span v-show="!moreDetails"
                                      class="cursor-pointer"
                                      @click="moreDetails = true"
                                >mais dados...</span>
                                <span v-show="moreDetails"
                                      class="cursor-pointer"
                                      @click="moreDetails = false"
                                >menos dados...</span>
                            </div>

                            <!-- juros -->
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="interest_type" value="Tipo de juros"/>
                                <jet-auto-complete
                                    id="interest_type" class="mt-1 block w-full"
                                    :options-list="interestTypes"
                                    v-model="form.interest_type"/>
                            </div>
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="interest_amount" value="Juros"/>
                                <jet-decimal id="interest_amount" type="text" class="mt-1 block w-full text-lg"
                                             v-model="form.interest_amount"/>
                                <jet-input-error :message="form.error('interest_amount')" class="mt-2"/>
                            </div>
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="interest_date" value="A partir de"/>
                                <jet-date-picker v-model="form.interest_date"
                                                 :disabled-dates="{to: moment(form.dadosBoleto.dtVencimento).add(1, 'day').toDate() || null}"
                                                 class="mt-1"/>
                                <jet-input-error :message="form.error('interest_date')" class="mt-2"/>
                            </div>
                            <!-- multa -->
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="fine_type" value="Tipo de multas"/>
                                <jet-auto-complete
                                    id="fine_type" class="mt-1 block w-full"
                                    :options-list="fineTypes"
                                    v-model="form.fine_type"/>
                            </div>
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="fine_amount" value="Multa"/>
                                <jet-decimal id="fine_amount" type="text" class="mt-1 block w-full text-lg"
                                             v-model="form.fine_amount"/>
                                <jet-input-error :message="form.error('fine_amount')" class="mt-2"/>
                            </div>
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="fine_date" value="A partir de"/>
                                <jet-date-picker v-model="form.fine_date"
                                                 :disabled-dates="{to: moment(form.dadosBoleto.dtVencimento).add(1, 'day').toDate() || null}"
                                                 class="mt-1"/>
                                <jet-input-error :message="form.error('fine_date')" class="mt-2"/>
                            </div>
                            <!-- desconto -->
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="discount_type" value="Tipo de descontos"/>
                                <jet-auto-complete
                                    id="discount_type" class="mt-1 block w-full"
                                    :options-list="discountTypes"
                                    v-model="form.discount_type"/>
                            </div>
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="discount_amount" value="Desconto"/>
                                <jet-decimal id="discount_amount" type="text" class="mt-1 block w-full text-lg"
                                             v-model="form.discount_amount"/>
                                <jet-input-error :message="form.error('discount_amount')" class="mt-2"/>
                            </div>
                            <div v-show="moreDetails" class="col-span-6 sm:col-span-2">
                                <jet-label for="discount_date" value="Até o dia"/>
                                <jet-date-picker v-model="form.discount_date"
                                                 :disabled-dates="{from: moment(form.dadosBoleto.dtVencimento).subtract(1, 'day').toDate() || null}"
                                                 class="mt-1"/>
                                <jet-input-error :message="form.error('discount_date')" class="mt-2"/>
                            </div>
                        </template>
                    </jet-form-section>
                </template>
                <jet-section-border/>
            </div>
        </div>

    </app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout'
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import JetFormSection from "../../Jetstream/FormSection";
import JetInput from "../../Jetstream/Input";
import JetTextarea from "../../Jetstream/Textarea";
import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import JetInputError from "../../Jetstream/InputError";
import JetLabel from "../../Jetstream/Label";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetMaskedInput from "../../Jetstream/MaskedInput";
import JetFetchDoc from "../../Jetstream/FetchDoc";
import JetDatePicker from "../../Jetstream/DatePicker";
import JetRadio from "../../Jetstream/Radio";
import JetDecimal from "../../Jetstream/Decimal";
import JetConfirmationModal from "../../Jetstream/ConfirmationModal";
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import Flash from "../../Helpers/Flash"
import moment from 'moment/dist/moment';

export default {
    props: ['goal_list', 'errors', 'boleto'],
    methods: {
        save() {
            const endpoint = this.boleto.id ? `/boleto/${this.boleto.id}` : '/boleto';
            this.form._method = 'PUT';
            this.form.post(endpoint, {
                resetOnSuccess: true,
                onError: (e) => {
                    this.form.processing = false;
                }
            });
        },
        customOption: (option) => {
            let bankName = option.bank.code === '274' ? `Conta ${$page.props.white_label.data.short_name}` : option.bank.name;
            return `${option.name} | <span class="text-xs">${bankName} | ${option.number}-${option.digit}</span>`;
        },
        preValidateForm() {
            this.form.errors = {};
            this.reviewBoleto = true;
            if (Object.keys(this.form.errors).length) {
                return false;
            }
            return true;
        }
    },
    computed: {
        checkBilletStatus() {
            return ["paid", "error"].includes(this.boleto.status)
        },
    },
    data() {
        return {
            moment: moment,
            flashIsVisible: true,
            reviewBoleto: false,
            moreDetails: false,
            cancelTransfer: null,
            form: this.$inertia.form({
                _method: 'PUT',
                ...this.boleto

            }, {
                resetOnSuccess: false,
            }),
            interestTypes: [
                {id: '1', name: 'Valor fixo'},
                {id: '2', name: 'Percentual ao dia'},
                {id: '3', name: 'Percentual ao mês'},
                {id: '5', name: 'Isento'},
            ],
            fineTypes: [
                {id: '1', name: 'Valor fixo'},
                {id: '2', name: 'Percentual'},
                {id: '3', name: 'Isenta'},
            ],
            discountTypes: [
                {id: '0', name: 'Isento'},
                {id: '1', name: 'Valor fixo'},
                {id: '2', name: 'Percentual'},
                {id: '3', name: 'Valor por antecipação'},
                {id: '5', name: 'Percentual por antecipação'},
            ],
        }
    },
    components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetRadio,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        JetDatePicker,
        JetDecimal,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton
    },
}
</script>
